import script from "./TryThisPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./TryThisPill.vue?vue&type=script&setup=true&lang=ts"

import "./TryThisPill.vue?vue&type=style&index=0&id=e96eb3ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e96eb3ec"]])

export default __exports__